import { chatQueryKeys as e } from "./useChatQueryKeys.mjs";
import { applyUnarchiveOptimistically as t } from "./archiveCacheUpdate.mjs";
import { useChatTransport as n } from "../transport/ChatTransportContext.mjs";
import { useMutation as r, useQueryClient as i } from "@maat/store-hooks";
//#region src/hooks/useUnarchiveConversationMutation.ts
var a = () => {
	let a = i(), { api: o } = n();
	return r({
		mutationFn: async ({ conversationId: e }) => o.unarchiveConversation ? o.unarchiveConversation(e) : { archived_at: null },
		onMutate: ({ conversationId: e }) => t(a, e),
		onError: (e, t, n) => {
			for (let [e, t] of n?.previous ?? []) a.setQueryData(e, t);
			n?.single?.data && a.setQueryData(n.single.key, n.single.data);
		},
		onSettled: (t, n, { conversationId: r }) => {
			a.invalidateQueries({ queryKey: e.conversations() }), a.invalidateQueries({ queryKey: e.conversation(r) });
		}
	});
};
//#endregion
export { a as useUnarchiveConversationMutation };
